const getGoodFriday = (year: number): { month: number; date: number } => {
  let temp: number;
  let m: number;
  let d: number;
  let tA: number;
  let tC: number;

  const firstDig = Math.floor(year / 100);

  const remain19 = year % 19;

  // calculate Pascal Full Moon date
  temp = Math.floor((firstDig - 15) / 2) + 202 - 11 * remain19;

  if ([21, 24, 25, 27, 28, 29, 30, 31, 32, 34, 35, 38].indexOf(firstDig) > -1) {
    temp -= 1;
  } else if ([33, 36, 37, 39, 40].indexOf(firstDig) > -1) {
    temp -= 2;
  }

  temp %= 30;

  tA = temp + 21;

  if (temp === 29) {
    tA -= 1;
  }
  if (temp === 28 && remain19 > 10) {
    tA -= 1;
  }

  // find the next Sunday
  const tB = (tA - 19) % 7;

  tC = (40 - firstDig) % 4;

  if (tC === 3) {
    tC += 1;
  }
  if (tC > 1) {
    tC += 1;
  }

  temp = year % 100;

  const tD = (temp + Math.floor(temp / 4)) % 7;

  const tE = ((20 - tB - tC - tD) % 7) + 1;
  d = tA + tE;

  // we want Good Friday, not Easter (Sunday)
  d -= 2;

  if (d > 31) {
    d -= 31;
    m = 3;
  } else {
    m = 2;
  }

  return { month: m, date: d };
};

const isGoodFriday = (
  month: number,
  date: number,
  dayOfWeek: number,
  year: number
): boolean => {
  const goodFriday = getGoodFriday(year);
  return (
    month === goodFriday.month && date === goodFriday.date && dayOfWeek === 5
  );
};

export default isGoodFriday;
